import { render, staticRenderFns } from "./BeboxDetail.vue?vue&type=template&id=4125b206&"
import script from "./BeboxDetail.vue?vue&type=script&lang=js&"
export * from "./BeboxDetail.vue?vue&type=script&lang=js&"
import style0 from "./BeboxDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports